import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { Header } from './header';
import { Footer } from './footer';
import { useStore } from '@/store';
import { useStoreInfo } from '@/lib/store';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { MaintenancePage } from '../site-lock/maintenance';
import { Sidebar } from './sidebar';
import { InstallPrompt } from '../pwa/install-prompt';

export function RootLayout() {
  const darkMode = useStore((state) => state.darkMode);
  const location = useLocation();
  const { storeInfo } = useStoreInfo();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (storeInfo?.site_lock === 2) {
    return <MaintenancePage />;
  }

  return (
    <div className={darkMode ? 'dark' : ''}>
      <div className="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-900">
        <Sidebar />
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <InstallPrompt />
        <Toaster 
          position="top-center"
          toastOptions={{
            className: 'dark:bg-gray-800 dark:text-white',
          }}
        />
      </div>
    </div>
  );
}